export default __webpack_public_path__ + "static/media/herobg.159f8b37.jpg";